import {
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'spassu-code',
});

export const activityConnectRouteRef = createSubRouteRef({
  id: 'spassu-code/activity-connect',
  parent: rootRouteRef,
  path: '/connect/:activityId',
});

export const activityMetricsRouteRef = createSubRouteRef({
  id: 'spassu-code/activity-metrics',
  parent: rootRouteRef,
  path: '/metrics/:activityId',
});

export const controlPlaneActivityNewRouteRef = createSubRouteRef({
  id: 'spassu-code/control-plane-activity-new',
  parent: rootRouteRef,
  path: '/new/control-plane',
});

export const controlPlaneNewRouteRef = createExternalRouteRef({
  id: 'spassu-code/control-plane-new',
  optional: true,
});

export const controlPlaneConnectRouteRef = createExternalRouteRef({
  id: 'spassu-code/control-plane-connect',
  params: ['activityId'],
  optional: true,
});

export const controlPlaneCockpitRouteRef = createExternalRouteRef({
  id: 'spassu-code/control-plane-cockpit',
  params: ['activityId'],
  optional: true,
});
